import React from 'react';

const InfoConnection = () => {
    return (
        <div className={"rounded-[5px] w-full shadow-[0_1px_4px_-1px_#0000004d] bg-[orange] text-white text-xl font-bold py-0.5 px-5"}>
            Selecione um elemento para criar a conexão.
        </div>
    );
};

export default InfoConnection;